import * as ActionsGuest from "./Action";

export default {
  ...ActionsGuest,
};
